import { defaults } from 'lodash';

import {
    EcomErrorEvent,
    FunnelEvent,
    PaymentTypeEvent,
    ProductInformationEvent,
    PurchaseInformationEvent,
    ShippingInformationEvent,
} from 'app/data-layers/model/data-layer-event';
import { config } from 'app/config/config';

class DataLayerUtils {
    public static readonly pushEcomEventToDataLayer = (
        ecomDataLayer: ProductInformationEvent | PurchaseInformationEvent | ShippingInformationEvent | PaymentTypeEvent,
    ) => DataLayerUtils.pushToDataLayer(ecomDataLayer, true);

    public static readonly pushErrorEventToDataLayer = (dataLayerEvent: EcomErrorEvent) => {
        const defaultDataLayer: Required<EcomErrorEvent> = defaults(dataLayerEvent, {
            partner_id: '',
            customer_id: '',
            user_id: '',
        });

        DataLayerUtils.pushToDataLayer(defaultDataLayer);
    };

    public static readonly pushToDataLayer = (
        dataLayer:
            | EcomErrorEvent
            | FunnelEvent
            | ProductInformationEvent
            | PurchaseInformationEvent
            | ShippingInformationEvent
            | PaymentTypeEvent,
        resetEcommerce: boolean = false,
    ) => {
        if (config.ENABLE_DATA_LAYERS) {
            window.dataLayer = window.dataLayer || [];

            if (resetEcommerce) {
                window.dataLayer.push({ ecommerce: null });
            }

            window.dataLayer.push(dataLayer);
        }
    };
}

export { DataLayerUtils };
